import type { ReactNode } from 'react'
import { forwardTheme, tileVars } from './tileKit'
import './redesigns.css'

/**
 * The design's scope for a drawer body.
 *
 * Drawers render through a portal outside the page shell, so the shell's theme
 * variables and font do not reach them. This wrapper re-declares both on the
 * drawer content, so the sub-page (a form, a file list, an inquiry) is painted
 * with the same palette and face as the pages behind it.
 *
 * `fit`, for a short bottom sheet (the first-time explainer, the nudge
 * prompt): the content sizes to its own height instead of flooring at 60vh,
 * which is right for a full-screen sub-page but leaves a tall empty sheet
 * under two lines and a button.
 */
export default function AssetDrawerScope({
  accent,
  fit = false,
  children,
}: {
  accent: string
  fit?: boolean
  children: ReactNode
}) {
  return (
    <div
      className={
        'rda-font-schibsted flex flex-col bg-[var(--rda-surface)] p-4 text-[var(--rda-on-surface)] ' +
        (fit ? '' : 'h-full min-h-[60vh]')
      }
      style={tileVars(forwardTheme(accent))}
    >
      {children}
    </div>
  )
}
